export const LOAD_NODES = "LOAD_NODES";
export const LOAD_FILTER_TYPE_OPTIONS = "LOAD_FILTER_TYPE_OPTIONS";
export const SET_CLUSTERED = "SET_CLUSTERED";
export const SET_MAP_STYLE = "SET_MAP_STYLE";
export const SET_PRESETS = "SET_PRESETS";
export const SET_QUERY = "SET_QUERY";
export const SET_SELECTED_STATUS = "SET_SELECTED_STATUS";
export const SET_SELECTED_TYPES = "SET_SELECTED_TYPES";
export const SET_SELECTED_NODES = "SET_SELECTED_NODES";
